
import React, { useState, useEffect, useMemo, useRef } from "react";
import { UrlApi } from "../../../services/apirest";
import {
  Button,
  Box,
  Grid,
  Stack,
  Snackbar,
  TextField,
  Autocomplete,
  Alert,
} from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import moment from "moment"; // PARA LA FECHA
import AttachFileIcon from "@mui/icons-material/AttachFile"; //ADJUNTAR ARCHIVOS
import { v4 as uuidv4 } from "uuid"; //ADJUNTAR IMAGEN
import { enviarmails } from "../../../services/services"; //MAILS
import { logEventos } from "../../../services/services";
import UpdatedUploadFiles from "../../../services/UpdatedUploadFiles";
import Chip from "@mui/material/Chip";

function  NuevoReclamo(props) {
  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  var curr = new Date();
  curr.setDate(curr.getDate());
  var date = curr.toISOString().substring(0, 10);

  const [nroReclamo, setNroReclamo] = useState(uuidv4());
  const [uuid_tanques, setUuid_tanques] = useState(uuidv4());
  const [dataCliente, setDataCliente] = useState(props.dataCliente);
  const [motivosEmergencia, setMotivosEmergencia] = useState();
  const [prioridad, setPrioridad] = useState();
  const [motivoSeleccionado, setMotivoSeleccionado] = useState();
  const [direccionSeleccionada, setDireccionSeleccionada] = useState();
  const [mostrarNro, setMostrarNro] = useState(false);
  const [ultimaRow, setUltimaRow] = useState();
  const [direcciones, setDirecciones] = useState();
  const [cargo, setCargo] = useState();
  const [tanque, setTanque] = useState([]);
  const [tanqueSeleccionado, setTanqueSeleccionado] = useState([]);
  const [disabledGuardar, setDisabledGuardar] = useState(false);

  const [datosReclamo, setDatosReclamo] = useState({
    motivo: null,
    prioridad: null,
    valor: null,
    fecha_abierto: date,
    detalle: "",
    a_cargo: null,
    valor_a_cargo: null,
    // uuid_tanque: uuid_tanques,
  });

  const [datosTanques, setDatosTanques] = useState([
    {
      id_tanque: null,
      uuid_reclamo_tanque: uuid_tanques,
      usuario: localStorage.getItem("user"),
    },
  ]);

  //funcion para obtener motivos
  const obtenerMotivosEmergencia = () => {
    fetch(UrlApi + "/motivos_emergencias/activos/SinInstalacion")
      .then((data) => data.json())
      .then((data) => setMotivosEmergencia(data));
  };

  useEffect(() => {
    obtenerMotivosEmergencia();
  }, []);


  const obtenerDirecciones = () => {
    fetch(UrlApi + "/direccionesentrega/cli/" + dataCliente.id)
      .then((data) => data.json())
      .then((data) => setDirecciones(data));
  };
  //funcion que espera los cambios de la funcion de obtener familias
  useEffect(() => {
    obtenerDirecciones();
  }, []);

  //funcion para obtener prioridades
  const obtenerPrioridades = () => {
    fetch(UrlApi + "/desplegables/reclamos")
      .then((data) => data.json())
      .then((data) => setPrioridad(data));
  };
  //funcion que espera los cambios de la funcion de obtener familias
  useEffect(() => {
    obtenerPrioridades();
  }, []);

  const obtenerCargo = () => {
    fetch(UrlApi + "/desplegables/reclamos_cargo")
      .then((data) => data.json())
      .then((data) => setCargo(data));
  };
  //funcion que espera los cambios de la funcion de obtener familias
  useEffect(() => {
    obtenerCargo();
  }, []);

  //funcion para obtener motivos
  const obtenerUltimaRow = () => {
    fetch(UrlApi + "/reclamos/ultimarow")
      .then((data) => data.json())
      .then((data) => setUltimaRow(data));
  };
  //funcion que espera los cambios de la funcion de obtener familias
  useEffect(() => {
    obtenerUltimaRow();
  }, []);


  let numero_reclamo = ultimaRow
    ? ultimaRow[0].id_reclamo + 1
    : "no disponible";

  const handleClickOpenCrear = () => {
    setNroReclamo(uuidv4());
    setUuid_tanques(uuidv4());
    setMotivoSeleccionado([]);
    datosReclamo.prioridad = "";
    datosReclamo.detalle = "";
    datosReclamo.a_cargo = null;
    activarLimpieza();
  };

  const [usuarioMail, setUsuarioMail] = useState([]);

  const obtenerUsuarioMail = () => {
    fetch(UrlApi + "/reclamos_config/")
      .then((data) => data.json())
      .then((data) => setUsuarioMail(data));
  };

  useEffect(() => {
    obtenerUsuarioMail();
  }, []);

  const obtenerTanques = () => {
    fetch(UrlApi + "/tanques/dirent/" + direccionSeleccionada.id)
      .then((data) => data.json())
      .then((data) => setTanque(data));
  };

  useEffect(() => {
    if (direccionSeleccionada?.id) {
      obtenerTanques();
      setTanqueSeleccionado([]); // ← limpiar tanques al cambiar de dirección
    } else {
      setTanqueSeleccionado([]);
    }
  }, [direccionSeleccionada]);

  const guardarReclamo = async (e) => {
    logEventos(
      "Guardar nuevo reclamo",
      "Reclamos Granel",
      "Se guardó el nuevo reclamo",
      localStorage.getItem("user")
    );
    e.preventDefault();

    const estado =
      motivoSeleccionado?.categoria === 281 // instalacion
      // || 
      // motivoSeleccionado?.categoria === 282 // desconexion
        ? 275 //van a grua
        : 192; // los demas van a sus pestañas

    await fetch(UrlApi + "/reclamos/", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id_cliente: dataCliente.id,
        id_motivo: motivoSeleccionado.id_motivo,
        estado, // Asigna el estado dinámicamente
        prioridad: datosReclamo.prioridad,
        detalle: datosReclamo.detalle,
        fecha_abierto: datosReclamo.fecha_abierto,
        direccion_entrega: direccionSeleccionada.id,
        usuario: localStorage.getItem("user"),
        uuid: nroReclamo,
        a_cargo: datosReclamo.a_cargo,
        uuid_tanques: uuid_tanques,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("El reclamo se guardó exitosamente !");
          console.log("Guardado");
          // refresca la tabla de reclamoscli
          if (props.onRefresh) props.onRefresh();
          // cierra el componente para ir a reclamoscli
          if (props.onClose) props.onClose();
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al guardar el reclamo");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });

    usuarioMail &&
      usuarioMail.length > 0 &&
      usuarioMail.map((usuario) => {
        if (usuario.email_usuario) {
          enviarmails(
            usuario.email_usuario,
            Number(motivoSeleccionado.categoria) === 282
              ? "Área Técnica,nueva desconexion registrada"
              : "Área Técnica,nuevo reclamo registrado",
            `<p>Se ha registrado un nuevo reclamo para el área técnica</p>
            <table style="width: 50%; border-collapse: collapse; margin-top: 10px;">
              <tr>
                <td style="border: 1px solid #ccc; padding: 8px; font-weight: bold;">Cliente</td>
                <td style="border: 1px solid #ccc; padding: 8px;">${dataCliente.id} - ${dataCliente.razon_social}</td>
              </tr>
              <tr>
                <td style="border: 1px solid #ccc; padding: 8px; font-weight: bold;">Motivo</td>
                <td style="border: 1px solid #ccc; padding: 8px;">${motivoSeleccionado.descripcion_motivo}</td>
              </tr>
              <tr>
                <td style="border: 1px solid #ccc; padding: 8px; font-weight: bold;">Prioridad</td>
                <td style="border: 1px solid #ccc; padding: 8px;">${datosReclamo.valor}</td>
              </tr>
              <tr>
                <td style="border: 1px solid #ccc; padding: 8px; font-weight: bold;">Domicilio</td>
                <td style="border: 1px solid #ccc; padding: 8px;">${direccionSeleccionada.nombre_direccion}-${direccionSeleccionada.direccion_entrega}-${direccionSeleccionada.localidad}-${direccionSeleccionada.provincia}</td>
              </tr>
              <tr>
                <td style="border: 1px solid #ccc; padding: 8px; font-weight: bold;">Detalle</td>
                <td style="border: 1px solid #ccc; padding: 8px;">${datosReclamo.detalle}</td>
              </tr>
            </table>`
          );
        } else {
          console.warn(
            `El usuario con ID ${usuario.idreclamos_config} no tiene una dirección de correo electrónico válida.`
          );
        }
      });
    guardarTanque();
  };

  const guardarTanque = async () => {
    for (let tanque of tanqueSeleccionado) {
      await fetch(UrlApi + "/reclamos_tanques/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id_tanque: tanque.id_tanque,
          uuid_reclamo_tanque: nroReclamo,
          usuario: localStorage.getItem("user"),
          instalacion: 0
        }),
      })
        .then((res) => {
          if (!res.err) {
            console.log("Tanque guardado");
          } else {
            console.log("Error al guardar tanque");
          }
        })
        .catch((err) => {
          console.log(err.message);
        });
    }
    // PARA LIMPIAR LOS DATOS
    handleClickOpenCrear();
    setMostrarNro(true);
  };

  const handleClose = () => {
    if (props.vengo === "PedidosCli") {
      props.alta(false);
      props.tabla(true);
    } else {
      props.addReclamo(false);
      props.tabla(true);
    }
  };
  //Estados para pantalla
  const style = {
    backgroundColor: "#ffffff",
    width: "100%",
  };

  const almacenar = (e) => {
    setDatosReclamo({
      ...datosReclamo,
      [e.target.name]: e.target.value,
    });
  };

  // Esta función maneja el cambio en el Select de prioridad
  const almacenarPrioridad = (event) => {
    const selectedPrioridadId = event.target.value;
    const selectedPrioridad = prioridad.find(
      (p) => p.id === selectedPrioridadId
    );

    // Actualizar el estado con la prioridad seleccionada y su valor
    setDatosReclamo((prevState) => ({
      ...prevState,
      prioridad: selectedPrioridadId,
      valor: selectedPrioridad ? selectedPrioridad.valor : null, // Establecer el valor seleccionado o null si no se encuentra el cargo
    }));
  };

  // Esta función maneja el cambio en el Select de cargo
  const almacenarCargo = (event) => {
    const selectedCargoId = event.target.value;
    const selectedCargo = cargo.find((c) => c.id === selectedCargoId);

    // Actualizar el estado con la prioridad seleccionada y su valor
    setDatosReclamo((prevState) => ({
      ...prevState,
      a_cargo: selectedCargoId,
      valor_a_cargo: selectedCargo ? selectedCargo.valor : null, // Establecer el valor seleccionado o null si no se encuentra el cargo
    }));
  };

  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };

  const [limpiarAutocomplete, setLimpiarAutocomplete] = useState(false);
  // Función para activar la limpieza del autocompletado
  const activarLimpieza = () => {
    setLimpiarAutocomplete(true);
    setTanqueSeleccionado([]); // <- esto limpia el valor seleccionado
    // Después este tiempo, cambiar el valor de limpiarAutocomplete a false
    setTimeout(() => {
      setLimpiarAutocomplete(false);
    }, 500); // 1000 milisegundos = 1 segundo
  };

  //console.log("DATOSRECLAMO", datosReclamo);
  //console.log("prioridad: ", prioridad);
  // console.log("cargo: ", cargo);
  const [openCloseAdj, setOpenCloseAdj] = useState(false); //ADJUNTAR COMPROBANTE

  const handleOpenCloseAdj = (value) => {
    setOpenCloseAdj(value);
  };

  // bloqueo del boton
  useEffect(() => {
    // Verifica si los campos esenciales están vacíos o no definidos
    const camposIncompletos =
      !motivoSeleccionado ||
      !datosReclamo.prioridad ||
      !direccionSeleccionada ||
      !datosReclamo.detalle;

    setDisabledGuardar(camposIncompletos);
  }, [
    motivoSeleccionado,
    datosReclamo.prioridad,
    direccionSeleccionada,
    datosReclamo.detalle,
  ]);

  // console.log("DATA CLIENTE", dataCliente);
  return (
    <>
      <>
        <form onSubmit={guardarReclamo}>
          <Box
            mb={1}
            mt={1}
            backgroundColor="#ebebeb"
            p={2}
            border={0.5}
            borderColor={"#ABB2B9"}
            borderRadius={4}
          >
            <Grid container spacing={2} alignItems="center">
              <Grid item xs={4}>
                {limpiarAutocomplete === true ? (
                  <TextField fullWidth size="small" disabled label="Motivo" />
                ) : (
                  <Autocomplete
                    size="small"
                    focused
                    disableClearable
                    required
                    id="motivo"
                    noOptionsText={"Motivo INEXISTENTE"}
                    options={motivosEmergencia}
                    autoHighlight
                    getOptionLabel={(motivo) =>
                      motivo.id_motivo + "-" + motivo.descripcion_motivo
                    }
                    onChange={(event, value) => {
                      setMotivoSeleccionado(value);
                      setMostrarNro(false);
                      obtenerUltimaRow();
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {option.id_motivo} - {option.descripcion_motivo}
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        focused
                        required
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Motivo"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                )}
              </Grid>
              <Grid item xs={4}>
                <FormControl style={style} focused required>
                  <InputLabel>Prioridad</InputLabel>
                  <Select
                    size="small"
                    name="prioridad"
                    value={datosReclamo.prioridad}
                    label="Prioridad"
                    // onChange={almacenar}
                    onChange={almacenarPrioridad}
                  >
                    {prioridad
                      ? prioridad.map((prioridad) => (
                          <MenuItem key={prioridad.id} value={prioridad.id}>
                            {prioridad.valor}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={4}>
                <TextField
                  style={style}
                  label="Fecha"
                  name="fecha"
                  size="small"
                  type="date"
                  focused
                  required
                  fullWidth
                  inputProps={{
                    readOnly: true,
                  }}
                  value={moment(datosReclamo.fecha_abierto).format(
                    "YYYY-MM-DD"
                  )}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={6}>
                {limpiarAutocomplete === true ? (
                  <TextField
                    fullWidth
                    size="small"
                    disabled
                    label="Dirección de Entrega"
                  />
                ) : (
                  <Autocomplete
                    size="small"
                    focused
                    disableClearable
                    required
                    id="direccion"
                    noOptionsText={"Dirección INEXISTENTE"}
                    options={direcciones}
                    autoHighlight
                    getOptionLabel={(direccion) =>
                      `${direccion.direccion_entrega} (${direccion.nombre_direccion})`
                    }
                    onChange={(event, value) => {
                      setDireccionSeleccionada(value);
                    }}
                    renderOption={(props, option) => (
                      <Box
                        component="li"
                        key={option.id}
                        sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                        {...props}
                      >
                        {/* {option.id} -  */}
                        {option.direccion_entrega} ({option.nombre_direccion})
                      </Box>
                    )}
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        focused
                        required
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Dirección de Entrega"
                        inputProps={{
                          ...params.inputProps,
                        }}
                      />
                    )}
                  />
                )}
              </Grid>

              <Grid item xs={4}>
                {limpiarAutocomplete === true ? (
                  <TextField fullWidth size="small" disabled label="Tanque" />
                ) : (
                  <Autocomplete
                    multiple
                    disabled={!direccionSeleccionada}
                    size="small"
                    focused
                    id="id_tanque"
                    noOptionsText="Tanque INEXISTENTE"
                    options={tanque}
                    autoHighlight
                    clearOnEscape
                    value={tanqueSeleccionado || []}
                    getOptionLabel={(option) =>
                      option
                        ? `N° ${option.nro_serie} - cap. ${option.capacidad}`
                        : ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id_tanque === value.id_tanque
                    }
                    onChange={(event, value) => {
                      setTanqueSeleccionado(value);
                    }}
                    renderTags={(value, getTagProps) =>
                      value.map((option, index) => (
                        <Chip
                          key={option.id_tanque}
                          label={`N° ${option.nro_serie} - cap. ${option.capacidad}`}
                          {...getTagProps({ index })}
                        />
                      ))
                    }
                    renderInput={(params) => (
                      <TextField
                        style={style}
                        size="small"
                        placeholder="Tipee para buscar..."
                        {...params}
                        label="Tanques"
                      />
                    )}
                  />
                )}
              </Grid>

              <Grid item xs={2}>
                <FormControl style={style} focused>
                  <InputLabel>A Cargo De</InputLabel>
                  <Select
                    size="small"
                    name="a_cargo"
                    value={datosReclamo.a_cargo}
                    label="A Cargo De"
                    // onChange={almacenar}
                    onChange={almacenarCargo}
                  >
                    {cargo
                      ? cargo.map((cargo) => (
                          <MenuItem key={cargo.id} value={cargo.id}>
                            {cargo.valor}
                          </MenuItem>
                        ))
                      : null}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  style={style}
                  label="Detalles"
                  name="detalle"
                  size="small"
                  placeholder="..."
                  inputProps={{
                    maxLength: 500,
                  }}
                  focused
                  fullWidth
                  value={datosReclamo.detalle}
                  onChange={almacenar}
                  multiline
                  rows={3}
                />
              </Grid>
              <Grid item xs={4}>
                <Button
                  onClick={() => setOpenCloseAdj(!openCloseAdj)}
                  variant="outlined"
                  size="small"
                  startIcon={<AttachFileIcon />}
                >
                  ADJUNTAR DOCUMENTACIÓN
                </Button>
              </Grid>
            </Grid>
          </Box>
          <Box>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              mt={2}
            >
              <Button variant="contained" onClick={handleClose} color="error">
                Volver
              </Button>
              {mostrarNro ? (
                <label style={{ fontSize: "20px" }}>
                  Su número de reclamo es <b>{numero_reclamo}</b>
                </label>
              ) : null}
              <Button
                variant="contained"
                type="submit"
                color="success"
                disabled={disabledGuardar}
              >
                Guardar Reclamo
              </Button>
            </Grid>
          </Box>
          <br></br>
          <br></br>
          <br></br>
          <br></br>
        </form>
      </>
      <>
        <Stack spacing={2} sx={{ width: "100%" }}>
          <Snackbar
            open={openSnack}
            autoHideDuration={1500}
            onClose={handleCloseSnack}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              sx={{ width: "100%" }}
              style={{ backgroundColor: colormensaje, color: "black" }}
            >
              {mensaje}
            </Alert>
          </Snackbar>
        </Stack>
      </>
      {openCloseAdj ? ( // ADJUNTAR COMPROBANTES
        <UpdatedUploadFiles
          fileId={nroReclamo}
          open={openCloseAdj}
          setOpen={()=>setOpenCloseAdj(false)}
          title={"Adjuntar archivos"} />
      ) : null}
    </>
  );
}

export default NuevoReclamo;



//DESCONECTA . 192
//1ERO VA EL TECNICO Y DESCONECTA
//MANDAS LA GRYTA //----- Component --------------------------------------------------------/
// Developer : Nicolas Pascucci
// Creation Date : 14/12/2023
// Version : 1
// Description : Creación de un nuevo reclamo
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date : 11-3-2024
// Change by : Magali Perea
// Change description: Se amplió la longitud de caracteres del textfield "detalle" A 500 para un nuevo reclamo y puse el textfield multilínea (por esos los cambios visuales en pantalla).
//Se quitó la propiedad "requerido" para designar al encargado de los gastos del reclamo.
//
// Change Date :
// Change by :
// Change description:
// Developer : Daiana Curcio
// Creation Date : 20/3/2025
// Version : 1
// Description : Creación de un nuevo reclamo
//========================================================================/